import { Color } from '@precon-tools-suite-by-shared/precon-graphql-types';
import type { ColorConfig, ColorRecord } from '../options';
import * as C from '@kurkle/color';

export type ColorValueInput = Color | Color[keyof Color] | keyof Color;

export type ColorInput = ColorValueInput | string | number[] | C.Color | C.RGBA;

export type ColorTint =
    | '50'
    | '100'
    | '200'
    | '300'
    | '400'
    | '500'
    | '600'
    | '700'
    | '800'
    | '900';

export function isColorValueInput(value: unknown): value is ColorValueInput {
    return (
        typeof value === 'string' &&
        (value in Color || Object.values(Color).indexOf(value as Color) > -1)
    );
}

export function normalizeColorValue(input: ColorValueInput): Color {
    if (typeof input === 'string' && input in Color) return Color[input];
    return input as Color;
}

export function pickColorConfig(
    input: ColorValueInput,
    colorConfigs: ColorRecord<ColorConfig>
) {
    return colorConfigs[normalizeColorValue(input)];
}

export function getColor(
    input: ColorInput,
    colorConfigs: ColorRecord<ColorConfig>,
    tint: ColorTint = '500'
): C.Color {
    if (isColorValueInput(input)) {
        const config = pickColorConfig(input, colorConfigs);
        return new C.Color(
            getComputedStyle(document.body).getPropertyValue(
                `--${config.cssClassName}-${tint}`
            )
        );
    } else {
        return new C.Color(input);
    }
}
